import InnerPage from "../components/InnerPage";
import PageBanner from "../components/PageBanner";
import NewsCard from "../components/NewsCard";
import { enterpriseNews, industryNews } from "../data/site";

const tabs = [
  { id: "tab1", label: "企业动态" },
  { id: "tab2", label: "行业新闻" },
];

export default function News() {
  return (
    <InnerPage
      banner={<PageBanner title="新闻动态" en="NEWS" variant="news" />}
      tabs={tabs}
    >
      <section id="tab1" className="panel">
        <div className="container">
          <h2 className="small-title">企业动态</h2>
          <div className="news-grid">
            {enterpriseNews.map((item) => (
              <NewsCard key={item.id} news={item} />
            ))}
          </div>
        </div>
      </section>
      <section id="tab2" className="panel">
        <div className="container">
          <h2 className="small-title">行业新闻</h2>
          <div className="news-list">
            {industryNews.map((item) => (
              <NewsCard key={item.id} news={item} />
            ))}
          </div>
        </div>
      </section>
    </InnerPage>
  );
}
